import { call, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_API_KEYS_REQUEST,
  CREATE_API_KEY_REQUEST,
  GET_API_KEY_REQUEST,
  UPDATE_API_KEY_REQUEST,
  DELETE_API_KEY_REQUEST,
  LIST_API_KEYS_REQUEST,
  VALIDATE_API_KEY_REQUEST,
  // Import the action creators
  fetchApiKeysSuccess,
  fetchApiKeysFailure,
  createApiKeySuccess,
  createApiKeyFailure,
  getApiKeySuccess,
  getApiKeyFailure,
  updateApiKeySuccess,
  updateApiKeyFailure,
  deleteApiKeySuccess,
  deleteApiKeyFailure,
  listApiKeysSuccess,
  listApiKeysFailure,
  validateApiKeySuccess,
  validateApiKeyFailure,
} from "../actions/apiKeyRegistrationActions";
import {
  createApiKeyInApi,
  getApiKeyFromApi,
  listApiKeysFromApi,
  updateApiKeyInApi,
  deleteApiKeyFromApi,
  validateApiKeyInApi,
} from "../apis/apiKeyRegistrationApi";

// Create API Key Saga
function* createApiKeySaga(action) {
  try {
    console.log(
      `API Key Registration Saga - createApiKeySaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(createApiKeyInApi, action.payload);

    if (response.success) {
      // Fetch the created API key details
      const apiKeyDetails = yield call(getApiKeyFromApi, {
        apiKeyId: response.apiKeyId,
        tenantId: action.payload.tenantId,
      });

      yield put(createApiKeySuccess(apiKeyDetails));
    } else {
      yield put(
        createApiKeyFailure(response.error || "Failed to create API key")
      );
    }
  } catch (error) {
    console.error(
      `API Key Registration Saga - createApiKeySaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(createApiKeyFailure(error.message || "Failed to create API key"));
  }
}

// Get API Key Saga
function* getApiKeySaga(action) {
  try {
    console.log(
      `API Key Registration Saga - getApiKeySaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(getApiKeyFromApi, action.payload);
    yield put(getApiKeySuccess(response));
  } catch (error) {
    console.error(
      `API Key Registration Saga - getApiKeySaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(getApiKeyFailure(error.message || "Failed to get API key"));
  }
}

// List API Keys Saga
function* listApiKeysSaga(action) {
  try {
    console.log(
      `API Key Registration Saga - listApiKeysSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(listApiKeysFromApi, action.payload);
    yield put(listApiKeysSuccess(response));
  } catch (error) {
    console.error(
      `API Key Registration Saga - listApiKeysSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(listApiKeysFailure(error.message || "Failed to list API keys"));
  }
}

// Update API Key Saga
function* updateApiKeySaga(action) {
  try {
    console.log(
      `API Key Registration Saga - updateApiKeySaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(updateApiKeyInApi, action.payload);

    if (response.success) {
      // Fetch the updated API key details
      const apiKeyDetails = yield call(getApiKeyFromApi, {
        apiKeyId: response.apiKeyId,
        tenantId: action.payload.tenantId,
      });

      yield put(updateApiKeySuccess(apiKeyDetails));
    } else {
      yield put(
        updateApiKeyFailure(response.error || "Failed to update API key")
      );
    }
  } catch (error) {
    console.error(
      `API Key Registration Saga - updateApiKeySaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(updateApiKeyFailure(error.message || "Failed to update API key"));
  }
}

// Delete API Key Saga
function* deleteApiKeySaga(action) {
  try {
    console.log(
      `API Key Registration Saga - deleteApiKeySaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(deleteApiKeyFromApi, action.payload);

    if (response.success) {
      yield put(
        deleteApiKeySuccess({
          apiKeyId: action.payload.apiKeyId,
          message: response.message,
        })
      );
    } else {
      yield put(
        deleteApiKeyFailure(response.error || "Failed to delete API key")
      );
    }
  } catch (error) {
    console.error(
      `API Key Registration Saga - deleteApiKeySaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(deleteApiKeyFailure(error.message || "Failed to delete API key"));
  }
}

// Validate API Key Saga
function* validateApiKeySaga(action) {
  try {
    console.log(
      `API Key Registration Saga - validateApiKeySaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(validateApiKeyInApi, action.payload);
    yield put(validateApiKeySuccess(response));
  } catch (error) {
    console.error(
      `API Key Registration Saga - validateApiKeySaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      validateApiKeyFailure(error.message || "Failed to validate API key")
    );
  }
}

// Fetch API Keys Saga (alias for listApiKeys)
function* fetchApiKeysSaga(action) {
  try {
    console.log(
      `API Key Registration Saga - fetchApiKeysSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(listApiKeysFromApi, action.payload);
    yield put(fetchApiKeysSuccess(response.apiKeys || []));
  } catch (error) {
    console.error(
      `API Key Registration Saga - fetchApiKeysSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(fetchApiKeysFailure(error.message || "Failed to fetch API keys"));
  }
}

// Root Saga
export function* apiKeyRegistrationSaga() {
  yield takeEvery(CREATE_API_KEY_REQUEST, createApiKeySaga);
  yield takeEvery(GET_API_KEY_REQUEST, getApiKeySaga);
  yield takeEvery(LIST_API_KEYS_REQUEST, listApiKeysSaga);
  yield takeEvery(UPDATE_API_KEY_REQUEST, updateApiKeySaga);
  yield takeEvery(DELETE_API_KEY_REQUEST, deleteApiKeySaga);
  yield takeEvery(VALIDATE_API_KEY_REQUEST, validateApiKeySaga);
  yield takeEvery(FETCH_API_KEYS_REQUEST, fetchApiKeysSaga);
}

export default apiKeyRegistrationSaga;
